import React, { useEffect, useState } from "react";
import { Formik, Field,  ErrorMessage } from "formik";
import * as Yup from "yup";
import axiosInstance from "../axiosInstance";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BackendHeader from "../component/BackendHeader";

import { API_URL_All } from "../api";
import { Card, Col, Container, Row, Form, Button, } from "react-bootstrap";
import { CUSTOMER_LIST_PATH } from "../routes/customerRoutes";

const API_URL = `${API_URL_All}/api/users`; // API URL khách hàng

const AddCustomerCode = () => {
  const { id } = useParams();
    const navigate = useNavigate();
    const [customer, setCustomer] = useState(null);
   
    const [priceData, setPriceData] = useState({
      'Thương mại điện tử': {
        kg: { '0-16': '', '10-100': '' },
        m3: { '0-10': '', '10-100': '' },
      },
      'Tiểu ngạch': {
        kg: { '0-16': '', '10-100': '' },
        m3: { '0-10': '', '10-100': '' },
      },
    });
  
    // Ensure priceData has the necessary properties before rendering
    const getPrice = (category, unit, range) => {
      return priceData[category] && priceData[category][unit] ? priceData[category][unit][range] : '';
    };
  
    // Handle price data input change
    const handlePriceInputChange = (e, category, unit, range) => {
      const { value } = e.target;
      setPriceData((prevData) => {
        const updatedData = {
          ...prevData,
          [category]: {
            ...prevData[category],
            [unit]: {
              ...prevData[category][unit],
              [range]: value,
            },
          },
        };
  
        // Log the updated priceData to the console
        console.log(updatedData);
  
        return updatedData;
      });
    };
  
    useEffect(() => {
      if (id) {
        fetchCustomerDetails(id);
      }
    }, [id]);
    const fetchCustomerDetails = async (customerId) => {
      try {
        const response = await axiosInstance.get(`${API_URL}/${customerId}`);
        setCustomer(response.data);
    
        // Parse userLinePrice JSON string and set priceData
        const userLinePrice = response.data.userLinePrice;
        if (userLinePrice) {
          const parsedPriceData = JSON.parse(userLinePrice);  // Parse JSON string to object
          setPriceData(parsedPriceData);  // Set the parsed data into state
        }
      } catch (error) {
        console.error("Lỗi khi lấy dữ liệu khách hàng:", error);
      }
    };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setCustomer((prevCustomer) => ({
        ...prevCustomer,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      // Kiểm tra nếu có bất kỳ giá trị nào trống trong priceData
      const isPriceDataValid =
        Object.values(priceData['Thương mại điện tử']).every((unit) =>
          Object.values(unit).every((value) => value !== '')
        ) &&
        Object.values(priceData['Tiểu ngạch']).every((unit) =>
          Object.values(unit).every((value) => value !== '')
        );
  
      const userDto = {
        ...customer,
        userLinePrice: isPriceDataValid ? JSON.stringify(priceData) : undefined, // Nếu bảng giá không trống thì gửi, nếu trống thì không gửi
      };
  
      try {
        // Gửi yêu cầu PUT đến API để cập nhật thông tin
        const response = await axiosInstance.put(`${API_URL}/${id}/update`, userDto);
        if (response.status === 200) {
          toast.success("Cập nhật thành công!");
          navigate(CUSTOMER_LIST_PATH); // Điều hướng về trang danh sách khách hàng sau khi cập nhật thành công
        }
      } catch (error) {
        console.error("Lỗi khi cập nhật thông tin khách hàng:", error);
        toast.error("Có lỗi xảy ra khi cập nhật thông tin!");
      }
    };
    return (
      <div>
        <BackendHeader />
        <Container className="mt-5">
          <Card className="shadow-sm p-4">
            <h2 className="text-center mb-4 text-primary">Cập nhật mã khách hàng</h2>
  
            {/* Thông tin khách hàng */}
            <Card className="mb-3 p-3 border-0 shadow-sm">
              <h5 className="mb-2">Thông tin</h5>
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm="2">
                  Mã KH
                </Form.Label>
                <Col sm="4">
                  <Form.Control
                    type="text"
                    name="customerCode"
                    value={customer?.customerCode || ""}
                    onChange={handleInputChange}
                    placeholder="Nhập mã khách hàng"
                  />
                </Col>
              </Form.Group>
            </Card>
  
            {/* Bảng giá */}
            <Card className="p-3 border-0 shadow-sm">
              <h5 className="mb-3">Bảng giá</h5>
  
              {/* TMDT Prices */}
              <Row className="mb-3">
                <Col md={2}>
                  <h6 className="mb-2">TMDT</h6>
                </Col>
                <Col md={5}>
                  <Card className="p-3 border rounded">
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="me-2 mb-0">0-16</Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Thương mại điện tử', 'kg', '0-16')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Thương mại điện tử", "kg", "0-16")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ kg</Form.Label>
                      </Col>
                    </Row>
  
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="mb-0">10-100</Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Thương mại điện tử', 'kg', '10-100')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Thương mại điện tử", "kg", "10-100")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ kg</Form.Label>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col md={5}>
                  <Card className="p-3 border rounded">
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="me-2 mb-0">0-10 </Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Thương mại điện tử', 'm3', '0-10')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Thương mại điện tử", "m3", "0-10")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ M3</Form.Label>
                      </Col>
                    </Row>
  
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="mb-0">10-100</Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Thương mại điện tử', 'm3', '10-100')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Thương mại điện tử", "m3", "10-100")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ M3</Form.Label>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
  
              {/* Tiểu ngạch Prices */}
              <Row className="mb-3">
                <Col md={2}>
                  <h6 className="mb-2">Tiểu ngạch</h6>
                </Col>
                <Col md={5}>
                  <Card className="p-3 border rounded">
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="me-2 mb-0">0-16 </Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Tiểu ngạch', 'kg', '0-16')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Tiểu ngạch", "kg", "0-16")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ kg</Form.Label>
                      </Col>
                    </Row>
  
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="mb-0">10-100</Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Tiểu ngạch', 'kg', '10-100')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Tiểu ngạch", "kg", "10-100")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ kg</Form.Label>
                      </Col>
                    </Row>
                  </Card>
                </Col>
                <Col md={5}>
                  <Card className="p-3 border rounded">
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="me-2 mb-0">0-10 </Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Tiểu ngạch', 'm3', '0-10')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Tiểu ngạch", "m3", "0-10")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ M3</Form.Label>
                      </Col>
                    </Row>
  
                    <Row className="mb-2">
                      <Col xs="4" className="d-flex align-items-center">
                        <Form.Label className="mb-0">10-100</Form.Label>
                      </Col>
                      <Col xs="6">
                        <Form.Control
                          type="text"
                          value={getPrice('Tiểu ngạch', 'm3', '10-100')}
                          onChange={(e) =>
                            handlePriceInputChange(e, "Tiểu ngạch", "m3", "10-100")
                          }
                        />
                      </Col>
                      <Col xs="2" className="d-flex align-items-center">
                        <Form.Label className="fw-bold">/ M3</Form.Label>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Card>
  
            {/* Nút cập nhật và quay lại */}
            <div className="text-center mt-4">
              <button onClick={handleSubmit} type="submit" className="btn btn-success px-5 py-2 me-3">
                Cập nhật
              </button>
              <Button variant="secondary" onClick={() => navigate(CUSTOMER_LIST_PATH)}>
                Quay lại
              </Button>
            </div>
          </Card>
        </Container>
      </div>
    );
  };
  

export default AddCustomerCode;
